import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { DataService } from './shared/data.service';
import { AuthenticationService } from './shared/authentication.service';
import { environment } from '../environments/environment';

import '../style/app.scss';

@Component({
  selector: 'my-app', // <my-app></my-app>
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  url = 'https://relieftelemed.com';
  currentUser: string;
  mobileOpen = false;
  data;
  subscription;
  expandedSidebar = false;
  sidebarEnabled = false;
  toolbarEnabled = false;
  customClasses = environment.customClasses;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    translate: TranslateService
  ) {
    translate.addLangs(['en', 'es', 'fr']);
    translate.setDefaultLang('en');
    //
    // // this language will be used as a fallback when a translation isn't found
    // // in the current language
    // translate.setDefaultLang('fr');
    // // the lang to use, if the lang isn't available, it will use the current
    // // loader to get them
    // translate.use('fr');

    let browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr|es/) ? browserLang : 'en');
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('dashboard')) {
          this.expandedSidebar = true;
        } else {
          this.expandedSidebar = false;
        }
        this.subscription = this.dataService.data$.subscribe(data => {
          this.data = data;
          if (this.data && this.data.authenticated === undefined) {
            this.sidebarEnabled = this.isLoggedIn();
            this.toolbarEnabled = this.isLoggedIn();
          } else {
            this.sidebarEnabled = this.data.authenticated;
            this.toolbarEnabled = this.data.authenticated;
          }
        });
      }
    });
  }

  isLoggedIn(): boolean {
    return this.authenticationService.isLoggedIn();
  }

  onLogout(): void {
    this.authenticationService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts